module.exports = __webpack_public_path__ + "img/3_izbove.14392b4a.jpg";